
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.767 16A4.772 4.772 0 010 11.234V4.767A4.773 4.773 0 014.767 0h6.467A4.772 4.772 0 0116 4.767v6.467A4.771 4.771 0 0111.234 16zM1.61 4.767v6.467a3.157 3.157 0 003.157 3.157h6.467a3.157 3.157 0 003.157-3.157V4.767a3.158 3.158 0 00-3.157-3.157H4.767A3.157 3.157 0 001.61 4.766zM3.862 8a4.143 4.143 0 014.14-4.138A4.142 4.142 0 0112.139 8a4.142 4.142 0 01-4.137 4.138A4.143 4.143 0 013.862 8zm1.61 0a2.528 2.528 0 002.53 2.528A2.527 2.527 0 0010.529 8 2.528 2.528 0 008 5.47 2.53 2.529 0 005.47 8zm5.683-4.106a.992.992 0 01.992-.992.992.992 0 01.993.992.992.992 0 01-.993.99.992.992 0 01-.992-.991z"}})])
          )
        }
      }
    